<template>
  <restroom-outline :restroom="destination" />
</template>

<script>
import restroomOutline from '@/components/map/partials/destination_outline/restroom.vue';

export default {
  components: { restroomOutline },
  computed: {
    destination: ({ $store }) => $store.state.searchResult.destination,
  },
};
</script>



// WEBPACK FOOTER //
// restroom.vue?7447b9f8